import { render, staticRenderFns } from "./SelectAnswerTypeSelector.vue?vue&type=template&id=165a65d2&scoped=true&"
import script from "./SelectAnswerTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./SelectAnswerTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SelectAnswerTypeSelector.vue?vue&type=style&index=0&id=165a65d2&prod&lang=scss&scoped=true&deep=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a65d2",
  null
  
)

export default component.exports